export const NAV_LINKS = {
  dashboard: 'Dashboard',
  forecast: 'Forecasting',
  superUser: 'Super User',
};
